module.exports = "<table class=\"schema-model\" ng-class=\"{hidden: !schema}\">\n  <tr>\n    <td>\n      <a\n        class=\"toggle\"\n        ng-click=\"switchMode()\"\n        title=\"Switch to {{mode == 'schema' ? 'json' : 'schema'}}\">\n\n        ⇄\n      </a>\n    </td>\n    <td class=\"view json\" ng-show=\"mode === 'json'\"></td>\n    <td class=\"view schema\" ng-show=\"mode === 'schema'\"></td>\n  </tr>\n</table>\n\n";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/schema-model.html
 ** module id = 422
 ** module chunks = 0
 **/